// extracted by mini-css-extract-plugin
export default {"Logo":"iA6OibwB","s":"kvV3YnW6","m":"HtawQ28l","l":"XslVC2bt","xl":"HAxhaoIv"};